<script>
  import options from './NoSearchResults.options'
  export default options
</script>

<template>
  <template v-if="totalCount === 0">
    <div class="kb-general-search__no-results" aria-live="polite" aria-atomic="true" role="status">
        <h2>
          {{getLabel('noResultTitle')}}
        </h2>
        <p class="kb-general-search__no-results__summary">
          {{getLabel('noResultDesc')}}
        </p>
        <a :href="getLabel('noResultButtonHref')" class="kb-button kb-button--full-color-spot">
          {{getLabel('noResultButtonText')}}
        </a>
    </div>
  </template>
</template>
